export type BadgeType = 'circle' | 'banner' | 'small';

export interface TextBadge {
  /** 뱃지 id */
  id?: number;
  /** 뱃지 유형 */
  type: BadgeType;
  /** 뱃지 위치 */
  position?: number;
  /** 뱃지 색상 */
  color: string;
  /** 뱃지 텍스트 value */
  value: string;
  /** 뱃지가 복수개인 경우 구분하기 위해 사용되는 index */
  subIndex?: number;
}

export interface ProductTextBadge {
  /** 상품 id */
  id?: number;
  /** custom한 상품명 id */
  name?: string;
  /** 상품 뱃지들 */
  textBadgeList: TextBadge[];
}

export const PRODUCT_LIST_SELECTION_TYPES = ['MANUAL', 'RANKING', 'PERSONALIZED'] as const;
export type ProductListSelectionType = (typeof PRODUCT_LIST_SELECTION_TYPES)[number];

export const RANKING_FILTER_TYPES = ['CATEGORY', 'BRAND'] as const;
export type RankingFilterType = (typeof RANKING_FILTER_TYPES)[number];
